import { z } from 'zod';
import { AnalysisStatus, DamageSeverity, InvestmentRecommendation } from './car-enums';
import { LocalizedStringListSchema, LocalizedStringSchema } from './car';
import { DealScoreSchema } from './deal-score';
/**
 * AI car analysis contract (`ai_car_analysis` collection).
 * Every typed field is one the ingest bot writes (`mapAiToAnalysisDoc` in
 * apps/api/src/modules/ingest/ingest.mapper.ts) or Deal Score maintains. The
 * OpenAI generator and the fields only it (or the retired Python service)
 * produced were removed 2026-10-05; `.passthrough()` keeps any such key still
 * sitting on an old document readable.
 * Money fields are USD (qwen/hermes pipeline) — unlike Car pricing (CHF).
 */
export const AICarAnalysisSchema = z
    .object({
    _id: z.unknown().nullish(),
    /** Mongo ObjectId (as string) of the alpicar_cars document. */
    car_id: z.string(),
    listing_id: z.string(),
    data_source: z.string().default('ai_analysis'),
    analysis_status: z.nativeEnum(AnalysisStatus).default(AnalysisStatus.PENDING),
    // Vehicle identification (copied from source data)
    brand: z.string().nullish(),
    model: z.string().nullish(),
    year: z.number().int().nullish(),
    vin: z.string().nullish(),
    // Damage assessment
    damage_severity: z.nativeEnum(DamageSeverity).nullish(),
    // Repair cost (USD)
    repair_cost: z.number().nullish(),
    // Price analysis (USD)
    price_suggest: z.number().nullish(),
    // Market analysis
    market_value_estimate: z.number().nullish(),
    // Investment analysis
    profit_margin_estimate: z.number().nullish(),
    investment_recommendation: z.nativeEnum(InvestmentRecommendation).nullish(),
    // Summary / pros / cons
    summary: LocalizedStringSchema.nullish(),
    pros: LocalizedStringListSchema.nullish(),
    cons: LocalizedStringListSchema.nullish(),
    // Processing metadata
    processing_model: z.string().nullish(),
    // Deal Score (phase 10) — computed at ingest, refreshed daily
    deal_score: DealScoreSchema.nullish(),
    // Timestamps
    created_at: z.coerce.date().nullish(),
    updated_at: z.coerce.date().nullish(),
    analyzed_at: z.coerce.date().nullish(),
})
    .passthrough();
//# sourceMappingURL=ai-analysis.js.map